import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import s from './Ppt.scss';
// eslint-disable-next-line no-unused-vars
import slickcss from '../../../node_modules/slick-carousel/slick/slick.css';

class Ppt extends React.Component {
  render() {
    const { msid, totalCnt } = this.props;
    const slides = [];
    for (let i = 0; i < totalCnt; i += 1) {
      slides.push(
        `https://static.toiimg.com/photo/msid-${msid}/${msid}.jpg?pageno=${i +
          1}`,
      );
    }
    const settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      draggable: false,
      initialSlide: 1,
      infinite: false,
    };
    return (
      <div
        data-wrapper="ppt"
        data-wap={this.props.isWapView}
        className={`${s.slideshow_wrapper} as_inlineslideshow ${
          this.props.classes
        }`}
      >
        <Slider {...settings}>
          {slides.map(value => (
            <div className={s.slideimg_container}>
              <div className={s.sliderimg_wrapper}>
                <img alt={`ppt page number ${value}`} src={value} />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}

Ppt.propTypes = {
  msid: PropTypes.string.isRequired,
  totalCnt: PropTypes.number.isRequired,
  classes: PropTypes.string,
  isWapView: PropTypes.bool,
};

Ppt.defaultProps = {
  isWapView: false,
  classes: '',
};

export default Ppt;
